module.exports = __webpack_public_path__ + "img/envelope.61398382.svg";